
import request from '@/utils/request';
import axios from "@/utils/NewLive.js";

const AppLogin = '/app/login';
export function SetAppLogin(data) {
    return request({
        url: AppLogin,
        method: 'post',
        data
    });
}
export default {
  // 禁言用户接口
  forbiddenuser:'/forbiddenuser', //get 无参数 查询禁言列表; POST {userid,userName,headeImg}禁言用户; delete {id} 删除
  // 边看边买 新增/编辑
  activitybuy:'/activitybuy',// post 新增/编辑
  // 直播推荐
  activityrecommend:'/activityrecommend', //get 查询列表 post 编辑新增
  getUuidSer:'/uuid', //get 获取uuid
  addForbidden:'/forbiddenuser/add', // 同问
  minusForbidden:'/forbiddenuser/minus', // 同问
  people:'/activity/people', //  直播间人数
  watermarkList: '/watermark/page', // 查询水印列表
}
//根据id查询通道
export const getChannelForId = (id) => axios.get(`/passageway/detail/${id}`);
export const getWaterList = (params) => axios.get(`/watermark/page/${params}`);
